/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var group_header_template_directive_1 = require("./group-header-template.directive");
var group_header_column_template_directive_1 = require("./group-header-column-template.directive");
var group_header_component_1 = require("./group-header.component");
var group_footer_template_directive_1 = require("./group-footer-template.directive");
var group_panel_component_1 = require("./group-panel.component");
var group_indicator_component_1 = require("./group-indicator.component");
var shared_module_1 = require("../shared.module");
var drag_and_drop_module_1 = require("../dragdrop/drag-and-drop.module");
var exportedModules = [
    group_header_template_directive_1.GroupHeaderTemplateDirective,
    group_header_column_template_directive_1.GroupHeaderColumnTemplateDirective,
    group_footer_template_directive_1.GroupFooterTemplateDirective,
    group_header_component_1.GroupHeaderComponent,
    group_panel_component_1.GroupPanelComponent,
    group_indicator_component_1.GroupIndicatorComponent
];
/**
 * @hidden
 */
var GroupModule = /** @class */ (function () {
    function GroupModule() {
    }
    GroupModule.exports = function () {
        return [
            group_header_template_directive_1.GroupHeaderTemplateDirective,
            group_header_column_template_directive_1.GroupHeaderColumnTemplateDirective,
            group_footer_template_directive_1.GroupFooterTemplateDirective
        ];
    };
    GroupModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [exportedModules],
            exports: [exportedModules],
            imports: [common_1.CommonModule, shared_module_1.SharedModule, drag_and_drop_module_1.DragAndDropModule]
        })
    ], GroupModule);
    return GroupModule;
}());
exports.GroupModule = GroupModule;
